module.exports = __webpack_public_path__ + "components/modal-app-popup/static/chrome-icon-733a6d29bff510268a1aa48743b99201.webp";